import { DurationDiscount, LicencePlan, LicenceRequest, LicenceResponse } from "../types/licence.definition";
import { addDoctorsNow, createLicence, getAvailablePlans, getDurationDiscounts, getLicenceByFacility, scheduleDoctorRemovals, updateLicence } from "../webclients/licence.client";

// Last-resort fallback if GET /licences/duration-discounts fails (e.g. transient network
// error), so the Licence page can still show a price. The server bills from its own
// configuration regardless of what is displayed here.
const DEFAULT_DURATION_DISCOUNTS: DurationDiscount[] = [
  { contractDuration: "ONE_MONTH", paymentBillingMode: null, discountPercentage: 0 },
  { contractDuration: "ONE_YEAR", paymentBillingMode: "MONTHLY", discountPercentage: 10 },
  { contractDuration: "ONE_YEAR", paymentBillingMode: "ANNUAL_LUMP_SUM", discountPercentage: 15 },
  { contractDuration: "ONE_YEAR", paymentBillingMode: null, discountPercentage: 10 },
  { contractDuration: "THREE_YEARS", paymentBillingMode: null, discountPercentage: 20 },
  { contractDuration: "FIVE_YEARS", paymentBillingMode: null, discountPercentage: 30 },
];

export const licenceApi = {
  getLicenceByFacility: async (
    facilityId: string | number
  ): Promise<LicenceResponse> => {
    const response = await getLicenceByFacility(facilityId);
    return response.data;
  },

  getAvailablePlans: async (): Promise<LicencePlan[]> => {
    const response = await getAvailablePlans();
    return response.data;
  },

  createLicence: async (facilityId: string | number, data: LicenceRequest): Promise<LicenceResponse> => {
    const response = await createLicence(facilityId, data);
    return response.data;
  },

  updateLicence: async (
    facilityId: string | number,
    licenceId: number,
    data: LicenceRequest
  ): Promise<LicenceResponse> => {
    const response = await updateLicence(facilityId, licenceId, data);
    return response.data;
  },

  scheduleDoctorRemovals: async (facilityId: string | number, licenceId: number, doctorIds: number[]): Promise<void> => {
    await scheduleDoctorRemovals(facilityId, licenceId, doctorIds);
  },

  addDoctorsNow: async (facilityId: string | number, licenceId: number, count: number): Promise<LicenceResponse> => {
    const response = await addDoctorsNow(facilityId, licenceId, count);
    return response.data;
  },

  getDurationDiscounts: async (): Promise<DurationDiscount[]> => {
    try {
      const response = await getDurationDiscounts();
      return response.data;
    } catch (err) {
      console.warn("licenceApi.getDurationDiscounts: falling back to default duration discounts", err);
      return DEFAULT_DURATION_DISCOUNTS;
    }
  },
};
